import { Box, styled } from "@mui/material";

export const PreviewText = styled(Box)(({ theme }) => ({
  position: "relative",
  borderTop: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
  maxHeight: theme.spacing(24),
  overflow: "hidden",
  "&:after": {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    left: theme.spacing(0.5),
    right: theme.spacing(0.5),
    bottom: 0,
    backgroundImage:
      "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 88%)",
  },
}));
